import { ContactDuplicateField } from '../../../lib/types';

// parentAddPlayerContact refuses a credential already on the player and names
// which one, so the banner leaves those two to the field error they produce.
export const BLOCKED_DUPLICATE_FIELDS = [ContactDuplicateField.Email, ContactDuplicateField.Phone];
